"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNCOMPRESSED_COMMANDS = exports.KEEP_ALIVE_MS = exports.REQUEST_TIMEOUT_MS = exports.CONNECT_TIMEOUT_MS = exports.DEFAULT_PROVISION = exports.PROVISION_URL = void 0;
/** URL provision.json из официального клиента (API_Reference.md §14). */
exports.PROVISION_URL = 'https://gist.githubusercontent.com/aigilea/152b043823de7cfeacd06f348b78ec25/raw/provision.json';
exports.DEFAULT_PROVISION = {
    b: 'https://4pda.to/',
    d: 'app.4pda.to:993',
    w: 'appbk.4pda.to',
};
exports.CONNECT_TIMEOUT_MS = 10000;
exports.REQUEST_TIMEOUT_MS = 30000;
exports.KEEP_ALIVE_MS = 30000;
/** Команды, которые на TCP отправляются без deflate (как в Android-клиенте). */
exports.UNCOMPRESSED_COMMANDS = new Set(['ah', 'ma', 'el']);
